import React from "react";

import useSspSettings from "../../../hooks/useSspSettings";
import { ReactComponent as IconProfile18 } from "../../../icons/icon/18/a-icon-profile-18.svg";
import IconButton from "../../button/iconButton";

const LoginButton = () => {
  const { sspSignupPage } = useSspSettings();

  return (
    <IconButton
      href={sspSignupPage?.nodeId ? sspSignupPage.nodeId : ""}
      iconOnly
      variant="utility"
      size="sm"
    >
      <IconProfile18 />
    </IconButton>
  );
};

export default LoginButton;
